import ProviderAPI from "../../src/redux/ProviderAPI";

export const postLogin = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/login",
    data: data,
    headers: data.token,
  });

  return result;
};

export const getLogin = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/detailUser",
    data: data,
    headers: data.token,
    // headers: token,
  });

  return result;
};

export const postProfile = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/addProfile",
    data,
    // token,
    headers: data.token,
  });

  return result;
};

export const editPersonal = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/updatePersonal",
    data,
    headers: data.token,
  });

  return result;
};

export const changePassword = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/changePassword",
    data,
    headers: data.token,
  });

  return result;
};

export const resetPassword = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/forgotPassword",
    data,
    headers: data.token,
  });

  return result;
};

export const resetNewPassword = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/resetPassword",
    data,
    headers: data.token,
  });

  return result;
};

export const getPermissionUser = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/detailPermissionUser",
    data: data,
    headers: data.token,
    // headers: token,
  });

  return result;
};
